<template src="./home.html"></template>


<script>

import { save_data_2024 } from "@/api/api.js";
import Cookies from '@/components/layout/Cookie.vue'

export default {
  components: {
    Cookies
  },
  data: () => ({
    timeStamps: "",
    marchi: [

      {
        nome: "AGB",
        titolo: "Alban Giacomo",
        numero: 1,
        descrizione: "Serratura Sentinel e cilindro Tedee",

      },
      {
        nome: "ROV",
        titolo: "RoverPlastik",
        numero: 2,
        descrizione: "Nuova soglia Qanta",

      },
      {
        nome: "OLI",
        titolo: "Olivari",
        numero: 3,
        descrizione: "Tecniche e prestazioni delle superfiniture",

      },
      {
        nome: "SMW",
        titolo: "Simonswerk",
        numero: 4,
        descrizione: "Cerniera a scomparsa per portoncini Tectus 680",

      },
      {
        nome: "SCM",
        titolo: "SECUREMME",
        numero: 7,
        descrizione: "Cilindri modulari di sicurezza EVO",

      },
      {
        nome: "ATM",
        titolo: "ANTAMATIC",
        numero: 6,
        descrizione: "Motorizzazioni per persiane a battente",

      },
      {
        nome: "MVL",
        titolo: "MV-LINE",
        numero: 16,
        descrizione: "Bora, la zanzariera antivento",
      },
      {
        nome: "GUI",
        titolo: "GU Gretsch-Unitas",
        numero: 8,
        descrizione: "Serratura multipunto automatic ed antipanico ad infilare",

      },
      {
        nome: "GEZ",
        titolo: "Geze",
        numero: 5,
        descrizione: "Linea chiudiporta universali a slitta TS 3000/5000",

      },
      {
        nome: "PSC",
        titolo: "PosaClima",
        numero: 10,
        descrizione: "Nuovo sistema di posa per vetri",

      },
      {
        nome: "TCS",
        titolo: "Tecnostamp",
        numero: 11,
        descrizione: "Nuovi cardini con blocco antisfilamento",

      },
      {
        nome: "NEK",
        titolo: "Nekos",
        numero: 12,
        descrizione: "Sistemi per vasistas motorizzati a scomparsa",

      },
      {
        nome: "FPM",
        titolo: "Fapim",
        numero: 15,
        descrizione: "Maniglioni antipanico, certificazione via di fuga con CSI",

      },
      {
        nome: "OTL",
        titolo: "Otlav",
        numero: 14,
        descrizione: "Gamma cerniere Ursus e Ursus Maxi",

      },
      {
        nome: "DRM",
        titolo: "Dorma",
        numero: 9,
        descrizione: "Automazioni per portoncini a battente ED 100 e ED 250",

      },
      {
        nome: "CCE",
        titolo: "CCE",
        numero: 13,
        descrizione: "Nuove soglie Ulisse Woow e Idrozero Mini",

      },

      {
        nome: "ECO",
        titolo: "EcoLinea",
        numero: 17,
        descrizione: "Soluzioni tecniche per il montaggio delle maniglie",

      },
    ],
    immaginiMasonry: [
      "../img/2024/masonry/_DBS4434_01.jpg",
      "../img/2024/masonry/_DBS4446_01.jpg",
      "../img/2024/masonry/_DBS4465_01.jpg",
      "../img/2024/masonry/_DBS4504_01.jpg",
      "../img/2024/masonry/_DBS4822.jpg",
      "../img/2024/masonry/20160521_135726.jpg"
    ],

    rules: {
      required: value => !!value || "Richiesto.",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
        return pattern.test(value) || "Indirizzo email non valido.";
      },
      phone: value => {
        // eslint-disable-next-line
        const pattern = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/;
        return (
          (pattern.test(value) && value.length > 5) ||
          "Numero di telefono non valido."
        );
      },
      number: value => {
        return (
          (/^\d+$/g.test(value) && parseInt(value) > 0) ||
          "Numero di partecipanti non valido."
        );
      },
      maxPartecipanti: value => {
        return parseInt(value) <= 4 || "Massimo 4 partecipanti";
      },
      piva: value => {
        return (
          (/^\d+$/g.test(value) && value.length == 11) ||
          "Partita iva non valida"
        );
      },
      optional: value => {
        if (value == undefined) return true;
        if (value.length == 0) return true;
        if (!/^\d+$/g.test(value) || parseInt(value) < 0)
          return "Numero di partecipanti non valido.";
      }
    },

    form: {
      nome: undefined,
      email: undefined,
      telefono: undefined,
      partecipanti_adulti: undefined,
      partecipanti_bambini: undefined,
      privacy: false,
      isvalid: false,
      dataPartecipazione: null,
      fasciaOraria: []
    },

    tipologie: ['Falegnameria', 'Serramentista', 'Produttore porte', 'Mobiliere', 'ShowRoom infissi/porte', 'ShowRoom arredamenti', 'Progettista', 'Altro'],

    fasceOrarieVenerdi: ["9-10", "10-11", "11-12", "12-13", "14-15", "15-16", "16-17", "17-18"],
    fasceOrarieSabato: ["9-10", "10-11", "11-12", "12-13"],

    alert: "",
    tipoAlert: "success",
    loading: false
  }),

  mounted() {
    this.timeStamps = this.getTime();

    window.addEventListener("resize", this.ridimensionaMasonry);
  },

  methods: {
    getTime() {
      var retrn = { days: 0, hours: 0, minutes: 0, seconds: 0, dist: 0 };
      var countdownDate = new Date(2024, 9, 4, 9, 0, 0).getTime();
      var now = new Date().getTime();
      var dist = countdownDate - now;
      retrn.days = Math.floor(dist / (1000 * 60 * 60 * 24));
      retrn.hours = Math.floor(
        (dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      retrn.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      retrn.seconds = Math.floor((dist % (1000 * 60)) / 1000);
      retrn.dist = dist;

      return retrn;
    },

    async inviaAdesione() {
      this.$refs.formAdesione.validate();

      if (!this.form.isvalid) {
        document
          .getElementById("formAdesione__invia")
          .classList.add("validation-error");

        setTimeout(() => {
          document
            .getElementById("formAdesione__invia")
            .classList.remove("validation-error");
        }, 600);

        return;
      }

      this.loading = true;
      this.alert = "";

      try {
        await save_data_2024(this.form)

        this.loading = false;

        this.tipoAlert = "success";
        this.alert = "Registrazione avvenuta con successo.";

      } catch (err) {
        this.loading = false;

        this.tipoAlert = "warning";
        this.alert = err.response ? err.response.data : err.message;
      }


    },


    ridimensionaMasonry() {
      let id = "masonry";
      var obj = document.getElementById(id).childNodes;
      for (var i = 0; i < obj.length; i++) {
        let val = obj[i].childNodes[0];
        let scaleFac = obj[i].clientWidth / val.clientWidth;
        val.style.transform = "";
        val.style.transform =
          "translateY(-" +
          (val.clientHeight - 200) / 2 +
          "px) scale(" +
          scaleFac +
          ")";
        val.style.transformOrigin = "left center";
      }
    },

  },

  computed: {
    getFasciaOraria() {
      if (this.form.dataPartecipazione == "2024-10-04")
        return this.fasceOrarieVenerdi
      else if (this.form.dataPartecipazione == "2024-10-05")
        return this.fasceOrarieSabato

      return []
    },

    sortedAzienda() {
      return this.marchi.sort((a, b) => (a.numero - b.numero))
    }
  }
};
</script>
